
function WhiteCheck({ width = 12, height = 9 }) {
	return (
		<svg height={height} width={width} viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.2934 0.292431L4.00041 6.58543L1.70741 4.29243C1.5188 4.11027 1.2662 4.00948 1.00401 4.01176C0.741809 4.01403 0.490997 4.1192 0.305589 4.30461C0.12018 4.49002 0.0150115 4.74083 0.0127331 5.00303C0.0104547 5.26523 0.111249 5.51783 0.293407 5.70643L3.29341 8.70643C3.48093 8.8939 3.73524 8.99922 4.00041 8.99922C4.26557 8.99922 4.51988 8.8939 4.70741 8.70643L11.7074 1.70643C11.8896 1.51783 11.9904 1.26523 11.9881 1.00303C11.9858 0.740832 11.8806 0.49002 11.6952 0.304612C11.5098 0.119204 11.259 0.014035 10.9968 0.0117566C10.7346 0.00947813 10.482 0.110272 10.2934 0.292431V0.292431Z"
				fill="white"
			/>
		</svg>
	);
}

export default WhiteCheck;
